import React from "react";
import "../css/main.css";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { connect } from "react-redux";
import { actions } from "@/store/actions/result";
import { Constants } from "../const/result";
import { Toast } from "antd-mobile";
import { splineOptions } from "../utils/chartOptions";
import { browser } from "../utils/utils";
import DownloadInfo from "@/components/DownloadInfo";

const speedTransfer = (speed) => {
  let re = "";
  if (speed === 0) {
    re = "0M";
  } else if (speed > 0 && speed < 2) {
    re = "0~2M";
  } else if (speed >= 2 && speed < 5) {
    re = "2~5M";
  } else if (speed >= 5 && speed < 10) {
    re = "5~10M";
  } else if (speed >= 10 && speed < 20) {
    re = "10~20M";
  } else if (speed >= 20 && speed < 50) {
    re = "20~50M";
  } else if (speed >= 50 && speed < 100) {
    re = "50~100M";
  } else if (speed >= 100 && speed < 200) {
    re = "100~200M";
  } else if (speed >= 200 && speed < 300) {
    re = "200~300M";
  } else if (speed >= 300 && speed < 500) {
    re = "300~500M";
  } else if (speed >= 500 && speed < 1000) {
    re = "500~1000M";
  } else {
    re = "1000M以上";
  }
  return re;
};

const rocketPosition = (speed) => {
  let re = "";
  if (speed === 0) {
    re = "2%";
  } else if (speed > 0 && speed < 10) {
    re = "10%";
  } else if (speed >= 10 && speed < 20) {
    re = "20%";
  } else if (speed >= 20 && speed < 50) {
    re = "30%";
  } else if (speed >= 50 && speed < 100) {
    re = "40%";
  } else if (speed >= 100 && speed < 200) {
    re = "55%";
  } else if (speed >= 200 && speed < 500) {
    re = "75%";
  } else {
    re = "95%";
  }
  return re;
};

class Result extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isp: "",
      ping: 0,
      downloadSpeed: 0,
      uploadSpeed: 0,
      splineOptions: splineOptions({ backgroundColor: "#312F2F" }),
    };
  }

  componentDidMount() {
    // this.getDownloadInfo();
    this.parseResult();
  }

  parseResult = () => {
    const result = JSON.parse(sessionStorage.getItem("testResult"));
    if (!result) return;
    this.setState({
      isp: result.isp,
      ping: result.ping,
      downloadSpeed: result.downloadSpeed,
      uploadSpeed: result.uploadSpeed,
      splineOptions: {
        series: [
          {
            color: Constants.DOWNLOAD_COLOR,
            data: result.downloadPoints,
          },
          {
            color: Constants.UPLOAD_COLOR,
            data: result.uploadPoints,
          },
        ],
      },
    });
  };

  // getDownloadInfo = () => {
  //   if (browser("ios")) return false;
  //   const callback = (res) => {
  //     console.log("请求结果：", res);
  //     if (!res.downloadUrl) {
  //       Toast.info("获取下载二维码失败");
  //       return false;
  //     }
  //     window.localStorage.setItem("downloadUrl", res.downloadUrl);
  //   };
  //   this.props.queryDownloadInfo({
  //     payload: { origin: "1", flavor: 1 },
  //     callback,
  //   });
  // };

  handleTestAgain = () => {
    sessionStorage.setItem("testMode", 1);
    this.props.history.push("/");
  };

  render() {
    const isIOS = browser("ios") || browser("iPhone");
    console.log("this.isIOS: ", isIOS);
    return (
      <div className="main">
        <div className="container">
          <div className="nav-bar">
            <span
              className="nav-left"
              onClick={() => this.props.history.goBack()}
            >
              <img
                className="nav-icon"
                src={require("../images/back.png")}
                alt="back"
              />
            </span>
            <span className="nav-title">测速详情</span>
            <span className="nav-right"></span>
            {/* <span className="nav-right"><img className="nav-icon" src={require('../images/share.png')} alt="share" /></span> */}
          </div>
          <div className="card">
            <div className="card-title">{this.state.isp}</div>
            <div className="speed-line-area">
              <img
                className="speed-rocket"
                style={{
                  left: `calc(${rocketPosition(
                    this.state.downloadSpeed
                  )} * 0.9)`,
                }}
                src={require("../images/rocket.png")}
                alt="rocket"
              />
              <div className="speed-line"></div>
            </div>
            <div className="speed-content">
              当前网速相当于{" "}
              <span className="bandwidth">
                {speedTransfer(this.state.downloadSpeed)}
              </span>{" "}
              带宽
            </div>
            <div className="info-row">
              <ul>
                <li>
                  <div className="sub-title">延时/ms</div>
                  <div className="sub-value">
                    {Math.floor(this.state.ping / 2) || "--"}
                  </div>
                </li>
                <li>
                  <div className="sub-title">下载/Mbps</div>
                  <div className="sub-value">
                    {this.state.downloadSpeed || "--"}
                  </div>
                </li>
                <li>
                  <div className="sub-title">上传/Mbps</div>
                  <div className="sub-value">
                    {this.state.uploadSpeed || "--"}
                  </div>
                </li>
              </ul>
            </div>
            <HighchartsReact
              highcharts={Highcharts}
              options={this.state.splineOptions}
            />
            <button
              className={`main-btn main-btn-start`}
              onClick={this.handleTestAgain}
            >
              再试一次
            </button>
            {/* {!isIOS && <DownloadInfo />} */}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ result }) => {
  return {
    data: result,
  };
};

const mapDispatchToProps = (dispatch) => ({
  // queryDownloadInfo: (data) => dispatch(actions.getDownloadInfo(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Result);
